import React from 'react';

import PropTypes from 'prop-types';

const FormCard = ({ children, actions }) => (
  <div className="shadow sm:rounded-md">
    <div className="px-4 py-6 bg-white sm:p-6">{children}</div>
    {actions && (
      <div className="px-4 py-3 text-right bg-gray-50 sm:px-6">{actions()}</div>
    )}
  </div>
);

FormCard.propTypes = {
  children: PropTypes.any,
  actions: PropTypes.func,
};

export default FormCard;
